import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { ArrowDownIcon } from '@/components/icons/main-block';
import { CloseIcon } from '@/components/icons/modal';

import cn from './styles.module.scss';

interface IModal {
    isOpen: boolean;
    onClose: VoidFunction;
    children: ReactNode;
    isNotAuth?: boolean;
    isHidden?: boolean;
}

export const ModalBase = ({ isOpen, onClose, children, isNotAuth = true, isHidden = false }: IModal) => {
    return (
        isOpen &&
        createPortal(
            <div className={clsx(cn.modalWrapper, { hidden: isHidden })}>
                <div className={clsx(cn.modal, isNotAuth && cn.isNotAuth)}>
                    <div className={cn.modalContainer}>
                        <div onClick={onClose} className={cn.backArrowBtn}>
                            {ArrowDownIcon}
                        </div>
                        {children}
                    </div>
                    <div onClick={onClose} className={cn.closeIcon}>
                        {CloseIcon}
                    </div>
                </div>
            </div>,
            document.body
        )
    );
};
